export default __webpack_public_path__ + "static/media/modern-calligraphy-mobile.11f7bb4e.png";